<app-card>
  <div class="d-flex justify-content-center alert alert-danger icons-alert">
    <span>Eish, page not found!</span>
  </div>
  <div class="row m-b-30">
    <i class="icofont icofont-ban text-default"></i>
  </div>
  <div class="row">
    <a [routerLink]="['/']">
      <button
        type="button"
        class="btn btn-primary waves-effect waves-light btn-lg"
      >
        <i class="icofont icofont-ui-home"></i>
        <span> Go home </span>
      </button>
    </a>
  </div>
</app-card>
